import React, { useEffect, useState } from 'react';
import { formFields, ConfigState, defaultState } from './'
import { Input } from "components/form/input";
import { GET_CONFIG, UPDATE_CONFIG } from "app/queries/Config";
import { useQuery, useMutation } from "@apollo/react-hooks";
import {ExecutionResult} from "graphql";
import { toast } from "react-toastify";


export function Config() {
  const [state, setState] = useState<ConfigState>(defaultState);
  const { data } = useQuery(GET_CONFIG);
  const [updateConfig]: any = useMutation(UPDATE_CONFIG);

  useEffect(() => {
    setState({...state, config: data?.config, loading: false});
  }, [data]);

  async function submitUpdateConfig() {
    setState({...state, loading: true})
    const response: ExecutionResult = await updateConfig({
      variables: {
        pricePerPerson: Number(state.config.pricePerPerson),
        pricePerMile: Number(state.config.pricePerMile),
        boatCapacity: Number(state.config.boatCapacity),
        allowSubmitRide: state.config.allowSubmitRide,
        noRideMessage: state.config.noRideMessage
      }
    })
    toast.success('Config Updated')
    setState({...state, loading: false})
  }

  if(state.loading) return <>Loading...</>

  return (
    <div className='config mb-3'>
      <h4>Settings</h4>
      <div className='row'>
        {
          state.config &&
          formFields.map((x, index) => <Input key={index} label={x.label} col={x.col} type={x.type} fieldName={x.fieldName} updateFormData={(field, text, validInput) => setState({...state, config: {...state.config, [field]: text}})} value={state.config[x.fieldName] ?? 0} />)
        }
        <div className='col-12 text-right'>
          <span className='btn btn-brand' onClick={() => submitUpdateConfig()}>Submit</span>
        </div>
      </div>
    </div>
  )
}
